import React, { useState, useEffect, useRef } from 'react';
import { supabase } from './supabaseClient';
import Login from './components/Login';
import SignUp from './components/SignUp';
import MyAccount from './components/MyAccount';
import Home from './components/Home';
import NewSession from './components/NewSession';
import Journal from './components/Journal';
import Meditation from './components/Meditation';
import HealingFormulasPage from './components/HealingFormulasPage';
import Companion from './components/Companion';
import Chat from './components/Chat';
import HealingFormulas from './components/HealingFormulas';
import Relationships from './components/Relationships';
import OneTimeIssue from './components/OneTimeIssue';
import Communication from './components/Communication';
import Unknown from './components/Unknown';
import IdentifyTheFeeling from './components/IdentifyTheFeeling';
import ChangeABelief from './components/ChangeABelief';
import Presence from './components/Presence';
import Validation from './components/Validation';
import Witness from './components/Witness';
import Celebrate from './components/Celebrate';
import SelfCare from './components/SelfCare';
import Weaknesses from './components/Weaknesses';
import Strengths from './components/Strengths';
import Trauma from './components/Trauma';
import Values from './components/Values';
import Rest from './components/Rest';
import Subconscious from './components/Subconscious';
import Reflection from './components/Reflection';
import Mirror from './components/Mirror';
import Honor from './components/Honor';
import HiddenBenefits from './components/HiddenBenefits';
import Gratitude from './components/Gratitude';
import Faith from './components/Faith';
import Dream from './components/Dream';
import Coping from './components/Coping';
import Accomplishments from './components/Accomplishments';
import Action from './components/Action';
import Acknowledge from './components/Acknowledge';
import Acceptance from './components/Acceptance';
import Abundance from './components/Abundance';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Astrology from './components/Astrology';
import KnowThyself from './components/KnowThyself';
import Affirmations from './components/Affirmations';
import QA from './components/QA';
import Oracle from './components/Oracle';
import Resistance from './components/Resistance';
import EnergyHealing from './components/EnergyHealing';
import AnimatedHelper from './components/AnimatedHelper';
import JulieCam from './components/JulieCam';
import AdminPanel from './components/AdminPanel';
import EndofSession from './components/EndofSession';
import RightForYou from './components/RightForYou';
import { Routes, Route } from 'react-router-dom';
import PrivacyPolicy from './components/PrivacyPolicy';

// Add this helper at the top (or near other helpers)
function getComponentNameFromResumeObj(pageObj) {
    // Accepts {component, questionId, animatedHelper, ...}
    if (!pageObj || typeof pageObj !== 'object') return null;
    // Normalize component name (e.g. rightforyou -> rightForYou)
    let comp = pageObj.component;
    if (!comp) return null;
    // Map lower-case to PascalCase or correct string if needed
    const map = {
        'rightforyou': 'healingFormulasPage/rightForYou',
        'knowthyself': 'healingFormulasPage/knowThyself',
        'selfcare': 'healingFormulasPage/selfCare',
        // Add more mappings as needed
    };
    // If already a full path, return as is
    if (comp.startsWith('healingFormulasPage/')) return comp;
    // Try mapping, else return as is
    return map[comp.toLowerCase()] || comp;
}

const AppContent = () => {
    const [currentPage, setCurrentPage] = useState(() => {
        (async () => {
            const sessionResult = await supabase.auth.getSession();
            let page = 'login';
            if (sessionResult.data && sessionResult.data.session) {
                let storedPage = localStorage.getItem('currentPage');
                if (storedPage && storedPage.toLowerCase() === 'mirror') {
                    storedPage = 'mirror';
                }
                if (storedPage) {
                    page = storedPage;
                } else {
                    page = 'home';
                }
            }
            setCurrentPage(page);
        })();
        return 'login';
    });
    const [pageHistory, setPageHistory] = useState([]);
    const [membershipType, setMembershipType] = useState('');
    // eslint-disable-next-line no-unused-vars
    const [animatedHelperData, setAnimatedHelperData] = useState(null);
    const [componentHelperData, setComponentHelperData] = useState(null);
    const [user, setUser] = useState(null);
    const resumeErrorShownRef = useRef(false);
    // (removed unused gpcOptOut state)

    const plans = [
        { id: 'P-6HJ79081Y2683844PM725QKI', name: 'Free Membership', desc: 'Free Access...' },
        { id: 'P-1C488387P5822563DM722QVA', name: 'Monthly Membership', desc: 'Billed Monthly...' },
        { id: 'P-33V688799T407630MM725RDI', name: 'Yearly Membership', desc: 'Billed Yearly...' }
    ];

    useEffect(() => {
        const recoverSession = async () => {
            const { data, error } = await supabase.auth.getSession();
            if (error || !data.session) {
                const storedSession = localStorage.getItem(`sb-${supabase.supabaseKey ? supabase.supabaseKey : 'project-ref'}-auth-token`);
                console.warn('recoverSession: No session found. localStorage session:', storedSession);
                const { error: refreshError } = await supabase.auth.refreshSession();
                if (refreshError) {
                    console.error('Session refresh failed:', refreshError.message, 'refreshError:', refreshError, 'data:', data);
                    setCurrentPage('login');
                }
            }
        };
        recoverSession();

        const getSession = async () => {
            const sessionResult = await supabase.auth.getSession();
            let page = 'login';
            if (sessionResult.data && sessionResult.data.session) {
                setUser(sessionResult.data.session.user);
                const storedPage = localStorage.getItem('currentPage');
                if (storedPage) {
                    page = storedPage;
                    if (page === 'adminPanel' && !isAdmin(sessionResult.data.session.user)) {
                        page = 'myAccount';
                        localStorage.setItem('currentPage', page);
                    }
                } else {
                    page = 'home';
                }
            } else {
                localStorage.setItem('currentPage', 'login');
                page = 'login';
            }
            console.log('App.js session check, stored page:', localStorage.getItem('currentPage'), 'Setting page to:', page);
            setCurrentPage(page);
        };
        getSession();

        const { data: listener } = supabase.auth.onAuthStateChange((event, session) => {
            console.log('Auth state change, session:', session);
            if (!session) {
                setCurrentPage('login');
                setUser(null);
            } else {
                setUser(session.user);
            }
        });

        return () => {
            listener.subscription.unsubscribe();
        };
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const userId = urlParams.get('userId');
        if (userId) {
            supabase.auth.getSession()
                .then(async ({ data, error }) => {
                    if (data && data.session) {
                        console.log('Session recovered');
                    } else {
                        let refresh_token = null;
                        try {
                            const v2Token = localStorage.getItem('supabase.auth.token');
                            if (v2Token) {
                                const parsed = JSON.parse(v2Token);
                                refresh_token = parsed.currentSession?.refresh_token || parsed.refresh_token;
                            }
                        } catch (e) {
                            // Ignore JSON parse errors
                        }
                        if (refresh_token) {
                            try {
                                const { data: refreshed, error: refreshError } = await supabase.auth.refreshSession({ refreshToken: refresh_token });
                                if (refreshed && refreshed.session) {
                                    console.log('Session refreshed');
                                } else {
                                    console.warn('Session refresh failed', refreshError);
                                }
                            } catch (refreshErr) {
                                console.warn('Session refresh failed', refreshErr);
                            }
                        } else {
                            console.warn('Session recovery failed', error);
                        }
                    }
                })
                .catch((err) => {
                    console.warn('Session recovery failed', err);
                });
        }
    }, []);

    useEffect(() => {
        let intervalId;

        const keepSessionAlive = async () => {
            try {
                const { data, error } = await supabase.auth.getSession();
                if (error || !data.session) {
                    await supabase.auth.refreshSession();
                }
            } catch (err) {
                // Optionally log error
            }
        };

        if (currentPage === 'signup' || currentPage === 'myAccount') {
            intervalId = setInterval(keepSessionAlive, 30000);
        }

        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [currentPage]);

    const setCurrentPageWithHistory = async (page, userData = null) => {
        // Support navigation via resume object (from resumeLastSession)
        const componentMap = {
            acknowledge: 'healingFormulasPage/acknowledge',
            accomplishments: 'healingFormulasPage/accomplishments',
            gratitude: 'healingFormulasPage/gratitude',
            strengths: 'healingFormulasPage/strengths',
            weaknesses: 'healingFormulasPage/weaknesses',
            values: 'healingFormulasPage/values',
            rest: 'healingFormulasPage/rest',
            reflection: 'healingFormulasPage/reflection',
            honor: 'healingFormulasPage/honor',
            hiddenbenefits: 'healingFormulasPage/hiddenBenefits',
            faith: 'healingFormulasPage/faith',
            dream: 'healingFormulasPage/dream',
            coping: 'healingFormulasPage/coping',
            action: 'healingFormulasPage/action',
            acceptance: 'healingFormulasPage/acceptance',
            abundance: 'healingFormulasPage/abundance',
            relationships: 'healingFormulasPage/relationships',
            communication: 'healingFormulasPage/communication',
            resistance: 'healingFormulasPage/resistance',
            energyhealing: 'healingFormulasPage/energyHealing',
            affirmations: 'healingFormulasPage/affirmations',
            knowthyself: 'healingFormulasPage/knowThyself',
            presence: 'healingFormulasPage/presence',
            trauma: 'healingFormulasPage/trauma',
            subconscious: 'healingFormulasPage/subconscious',
            onetimeissue: 'healingFormulasPage/oneTimeIssue',
            qa: 'qa',
            oracle: 'oracle',
            mirror: 'mirror',
            juliecam: 'julieCam',
            adminpanel: 'adminPanel',
            myaccount: 'myAccount',
            login: 'login',
            signup: 'signup',
            endofsession: 'endofSession',
            animatedhelper: 'animatedhelper',
        };

        function mapComponentName(name) {
            if (!name) return name;
            return componentMap[name.toLowerCase()] || name;
        }

        if (typeof page === 'object' && page !== null && page.component) {
            const mapped = mapComponentName(page.component);
            // If animatedHelper is true, set helper data and page
            if (page.animatedHelper) {
                setComponentHelperData({
                    component: mapped,
                    isActive: true,
                    questionId: page.questionId || null
                });
                setCurrentPage(mapped);
                localStorage.setItem('currentPage', JSON.stringify(page));
                return;
            }
            // If questionId is present, set helper data for question
            if (page.questionId) {
                setComponentHelperData({
                    component: mapped,
                    isActive: true,
                    questionId: page.questionId
                });
                setCurrentPage(mapped);
                localStorage.setItem('currentPage', JSON.stringify(page));
                return;
            }
            // Otherwise, just set the page
            setCurrentPage(mapped);
            localStorage.setItem('currentPage', JSON.stringify(page));
            return;
        }
        // Membership restriction logic
        // Only restrict if navigating to a page other than myAccount, login, or signup
        const unrestrictedPages = ['myAccount', 'login', 'signup'];
        if (page && !unrestrictedPages.includes(page)) {
            try {
                const { data: { user } } = await supabase.auth.getUser();
                if (user) {
                    const { data: profile, error: profileError } = await supabase
                        .from('user_profiles')
                        .select('membership_type')
                        .eq('id', user.id)
                        .single();
                    if (!profileError && profile) {
                        const allowed = ['Paid Subscription', 'Gift Subscription'];
                        if (!allowed.includes(profile.membership_type)) {
                            setCurrentPage('myAccount');
                            localStorage.setItem('currentPage', 'myAccount');
                            if (userData) setUser(userData);
                            return;
                        }
                    }
                }
            } catch (err) {
                setCurrentPage('myAccount');
                localStorage.setItem('currentPage', 'myAccount');
                if (userData) setUser(userData);
                return;
            }
        }
        if (!page || page === 'previousPage') return;
        setPageHistory((prev) => {
            if (prev[prev.length - 1] !== currentPage) {
                return [...prev, currentPage];
            }
            return prev;
        });
        // Always map string page names as well
        const mappedPage = typeof page === 'string' ? mapComponentName(page) : page;
        setCurrentPage(mappedPage);
        localStorage.setItem('currentPage', mappedPage);
        if (userData) setUser(userData);
    };

    const goBack = () => {
        setPageHistory((prev) => {
            if (prev.length > 0) {
                const newHistory = [...prev];
                const lastPage = newHistory.pop();
                setCurrentPage(lastPage);
                return newHistory;
            }
            return prev;
        });
    };

    console.log('Debug: Current page is', currentPage);
    console.log('Debug: Page history is', pageHistory);
    console.log('window.setCurrentPage assigned');
    window.setCurrentPage = setCurrentPageWithHistory;

    const navigateTo = async (answer) => {
        let componentName = typeof answer === 'string' ? answer : (answer?.component || answer?.path);
        let questionId = typeof answer === 'object' ? (answer?.questionId || answer?.nextQuestionId) : null;
        let answerHelperQuestionId = typeof answer === 'object' ? answer?.answerHelperQuestionId : null;

        console.log('navigateTo called with:', { answer, componentName, questionId });

        const { data: { user } } = await supabase.auth.getUser();
        if (!user && componentName !== 'login') {
            setCurrentPageWithHistory('login');
            return;
        }

        if (componentName) {
            // Pages listed here will NOT activate the AnimatedHelper when navigated to.
            // Historically only 'endofSession' was excluded. Add 'knowThyself' because
            // visiting KnowThyself from EndofSession should not start the helper.
            const nonHelperPages = ['endofSession', 'knowThyself', 'healingFormulasPage/knowThyself'];
            const isHelperPage = !nonHelperPages
                .map(p => p.toLowerCase())
                .includes(componentName.toLowerCase());
            if (isHelperPage) {
                setComponentHelperData({
                    component: componentName,
                    isActive: true,
                    questionId: questionId || componentHelperData?.questionId || null
                });
                console.log('Updated componentHelperData:', { component: componentName, questionId });
            } else {
                setComponentHelperData(null);
                setCurrentPageWithHistory(componentName);
                return;
            }
            // For all other navigation, update page and keep helper active
            setCurrentPageWithHistory(componentName);
            setComponentHelperData(prev => ({
                ...prev,
                component: componentName,
                questionId: questionId || prev?.questionId || null,
                answerHelperQuestionId: answerHelperQuestionId || prev?.answerHelperQuestionId || null,
                isActive: true
            }));
            return;
        }

        // --- FIX: Only clear helper for EndofSession or explicit close ---
        if (componentName && componentName.toLowerCase() === 'animatedhelper') {
            setComponentHelperData({
                component: currentPage,
                isActive: true,
                questionId: questionId || null,
                answerHelperQuestionId: answerHelperQuestionId || null
            });
            // Do NOT change currentPage
            return;
        }

        // If navigating to EndofSession, close helper
        if (componentName && componentName.toLowerCase() === 'endofsession') {
            setComponentHelperData(null);
            setCurrentPageWithHistory(componentName);
            return;
        }

        // --- FIX: When navigating from AnimatedHelper, persist helper question/answers if no nextQuestionId ---
        if (componentHelperData?.isActive) {
            if (componentName && componentName.toLowerCase() === 'endofsession') {
                setComponentHelperData(null);
                setCurrentPageWithHistory(componentName);
                return;
            }
            setCurrentPageWithHistory(componentName);
            setComponentHelperData(prev => ({
                ...prev,
                component: componentName,
                // Only update questionId/answerHelperQuestionId if a new one is provided (from next_question3_id or explicit), else persist previous
                questionId: (questionId !== null && questionId !== undefined) ? questionId : prev?.questionId,
                answerHelperQuestionId: (answerHelperQuestionId !== null && answerHelperQuestionId !== undefined) ? answerHelperQuestionId : prev?.answerHelperQuestionId,
                isActive: true
            }));
            return;
        }

        // If componentName is explicitly provided, activate AnimatedHelper with it
        if (componentName && componentName.toLowerCase() === 'animatedhelper') {
            setComponentHelperData({
                component: currentPage,
                isActive: true,
                questionId: questionId || null,
                answerHelperQuestionId: answerHelperQuestionId || null
            });
            // Do NOT change currentPage
            return;
        }

        // Default navigation
        setCurrentPageWithHistory(componentName);
    };

    const handleSaveProgress = async (componentName, questionId = null, animatedHelper = false) => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                toast.error('User not logged in. Please log in to save progress.');
                return false;
            }

            const progressData = {
                user_id: user.id,
                current_component: componentName.toLowerCase(),
                current_question_id: questionId,
                animated_helper: animatedHelper ? 'yes' : 'no', // always set explicitly
                timestamp: new Date().toISOString(),
            };

            const { error: progressError } = await supabase
                .schema('api')
                .from('user_progress')
                .upsert(progressData);

            if (progressError) {
                toast.error('Failed to save progress: ' + progressError.message);
                console.error('Supabase upsert error:', progressError.message);
                return false;
            }

            toast.success('Progress saved successfully!');
            return true;
        } catch (err) {
            toast.error('Failed to save progress. Please try again.');
            console.error('Error saving progress:', err);
            return false;
        }
    };

    const resumeLastSession = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                toast.error('User not logged in. Please log in to resume your session.');
                return;
            }

            const { data: progressData, error: progressError } = await supabase
                .schema('api')
                .from('user_progress')
                .select('*')
                .eq('user_id', user.id)
                .order('timestamp', { ascending: false })
                .limit(1);

            if (progressError || !progressData || progressData.length === 0) {
                toast.error('No progress found to resume.');
                return;
            }

            const lastProgress = progressData[0];
            const { current_component, current_question_id } = lastProgress;

            console.log('Debug: Resuming session with component:', current_component, 'and question ID:', current_question_id);

            const componentMap = {
                // IMPORTANT: This mapping is CRITICAL for correct resume navigation.
                // The values stored in user_progress.current_component are simple names (e.g., "accomplishments", "gratitude").
                // The app expects full component names (e.g., "healingFormulasPage/accomplishments").
                // If this mapping is removed or incomplete, resuming a session will result in blank pages for many sections.
                // DO NOT REMOVE OR EDIT WITHOUT ENSURING ALL PAGES RENDER CORRECTLY FROM RESUME.
                acknowledge: 'Acknowledge',
                accomplishments: 'healingFormulasPage/accomplishments',
                gratitude: 'healingFormulasPage/gratitude',
                strengths: 'healingFormulasPage/strengths',
                weaknesses: 'healingFormulasPage/weaknesses',
                values: 'healingFormulasPage/values',
                rest: 'healingFormulasPage/rest',
                reflection: 'healingFormulasPage/reflection',
                honor: 'healingFormulasPage/honor',
                hiddenbenefits: 'healingFormulasPage/hiddenBenefits',
                faith: 'healingFormulasPage/faith',
                dream: 'healingFormulasPage/dream',
                coping: 'healingFormulasPage/coping',
                action: 'healingFormulasPage/action',
                acceptance: 'healingFormulasPage/acceptance',
                abundance: 'healingFormulasPage/abundance',
                relationships: 'healingFormulasPage/relationships',
                communication: 'healingFormulasPage/communication',
                resistance: 'healingFormulasPage/resistance',
                energyhealing: 'healingFormulasPage/energyHealing',
                affirmations: 'healingFormulasPage/affirmations',
                knowthyself: 'healingFormulasPage/knowThyself',
                presence: 'healingFormulasPage/presence',
                trauma: 'healingFormulasPage/trauma',
                subconscious: 'healingFormulasPage/subconscious',
                onetimeissue: 'healingFormulasPage/oneTimeIssue',
                qa: 'qa',
                oracle: 'oracle',
                mirror: 'mirror',
                juliecam: 'julieCam',
                adminpanel: 'adminPanel',
                myaccount: 'myAccount',
                login: 'login',
                signup: 'signup',
                endofsession: 'endofSession',
                animatedhelper: 'animatedhelper',
            };

            const mappedComponent = componentMap[current_component.toLowerCase()] || current_component;

            if (mappedComponent === 'Acknowledge') {
                setCurrentPageWithHistory('acknowledge');
            } else if (mappedComponent === 'healingFormulasPage/accomplishments') {
                setCurrentPageWithHistory('healingFormulasPage/accomplishments');
            } else if (mappedComponent === 'animatedhelper') {
                console.log('Resuming AnimatedHelper with question ID:', current_question_id);
                showAnimatedHelper(current_question_id);
            } else {
                setCurrentPageWithHistory(mappedComponent);
            }
        } catch (err) {
            toast.error('Failed to resume last session. Please try again.');
            console.error('Error resuming last session:', err);
        }
    };

    const showAnimatedHelper = (questionId) => {
        setAnimatedHelperData({ questionId });
        setComponentHelperData({
            component: currentPage,
            isActive: true,
            questionId: questionId || null
        });
        console.log('showAnimatedHelper called with questionId:', questionId, 'currentPage:', currentPage);
    };

    const AnimatedHelperWrapper = () => {
        useEffect(() => {
            // Intentionally log on mount only; avoid referencing outer-scope
            // `componentHelperData` inside the effect dependency array which
            // can trigger false-positive lint warnings in this nested component.
            console.log('AnimatedHelperWrapper rendered');
        }, []);

        if (!componentHelperData?.isActive || componentHelperData.component === 'EndofSession') return null;

        return (
            <AnimatedHelper
                key={`${componentHelperData.questionId}-${componentHelperData.component}`}
                isActive={componentHelperData.isActive}
                initialQuestionId={componentHelperData.questionId}
                answerHelperQuestionId={componentHelperData.answerHelperQuestionId} // <-- forward this prop
                onButtonClick={navigateTo}
                onClose={() => setComponentHelperData(null)}
                parentComponent={componentHelperData.component}
                setCurrentPage={setCurrentPageWithHistory}
            />
        );
    };

    const components = [
        { name: 'healingFormulasPage/oneTimeIssue', component: OneTimeIssue, props: { handleSaveProgress: () => handleSaveProgress('OneTimeIssue') } },
        { name: 'healingFormulasPage/presence', component: Presence, props: { handleSaveProgress: () => handleSaveProgress('Presence') } },
        { name: 'healingFormulasPage/knowThyself', component: KnowThyself, props: { handleSaveProgress: () => handleSaveProgress('KnowThyself') } },
        { name: 'healingFormulasPage/weaknesses', component: Weaknesses, props: { handleSaveProgress: () => handleSaveProgress('Weaknesses') } },
        { name: 'healingFormulasPage/strengths', component: Strengths, props: { handleSaveProgress: () => handleSaveProgress('Strengths') } },
        { name: 'healingFormulasPage/subconscious', component: Subconscious, props: { handleSaveProgress: () => handleSaveProgress('Subconscious') } },
        { name: 'healingFormulasPage/trauma', component: Trauma, props: { handleSaveProgress: () => handleSaveProgress('Trauma') } },
        { name: 'healingFormulasPage/values', component: Values, props: { handleSaveProgress: () => handleSaveProgress('Values') } },
        { name: 'healingFormulasPage/rest', component: Rest, props: { handleSaveProgress: () => handleSaveProgress('Rest') } },
        { name: 'healingFormulasPage/reflection', component: Reflection, props: { handleSaveProgress: () => handleSaveProgress('Reflection') } },
        { name: 'healingFormulasPage/honor', component: Honor, props: { handleSaveProgress: () => handleSaveProgress('Honor') } },
        { name: 'healingFormulasPage/hiddenBenefits', component: HiddenBenefits, props: { handleSaveProgress: () => handleSaveProgress('HiddenBenefits') } },
        { name: 'healingFormulasPage/gratitude', component: Gratitude, props: { handleSaveProgress: () => handleSaveProgress('Gratitude') } },
        { name: 'healingFormulasPage/faith', component: Faith, props: { handleSaveProgress: () => handleSaveProgress('Faith') } },
        { name: 'healingFormulasPage/dream', component: Dream, props: { handleSaveProgress: () => handleSaveProgress('Dream') } },
        { name: 'healingFormulasPage/coping', component: Coping, props: { handleSaveProgress: () => handleSaveProgress('Coping') } },
        { name: 'healingFormulasPage/accomplishments', component: Accomplishments, props: { handleSaveProgress: () => handleSaveProgress('Accomplishments') } },
        { name: 'healingFormulasPage/action', component: Action, props: { handleSaveProgress: () => handleSaveProgress('Action') } },
        { name: 'healingFormulasPage/acknowledge', component: Acknowledge, props: { handleSaveProgress: () => handleSaveProgress('Acknowledge') } },
        { name: 'healingFormulasPage/acceptance', component: Acceptance, props: { handleSaveProgress: () => handleSaveProgress('Acceptance') } },
        { name: 'healingFormulasPage/abundance', component: Abundance, props: { handleSaveProgress: () => handleSaveProgress('Abundance') } },
        { name: 'healingFormulasPage/relationships', component: Relationships, props: { handleSaveProgress: () => handleSaveProgress('Relationships') } },
        { name: 'healingFormulasPage/communication', component: Communication, props: { handleSaveProgress: () => handleSaveProgress('Communication') } },
        { name: 'healingFormulasPage/resistance', component: Resistance, props: { handleSaveProgress: () => handleSaveProgress('Resistance') } },
        { name: 'healingFormulasPage/energyHealing', component: EnergyHealing, props: { handleSaveProgress: () => handleSaveProgress('EnergyHealing') } },
        { name: 'healingFormulasPage/affirmations', component: Affirmations, props: { handleSaveProgress: () => handleSaveProgress('Affirmations') } },
        { name: 'healingFormulasPage/unknown', component: Unknown, props: { handleSaveProgress: () => handleSaveProgress('Unknown') } },
        { name: 'endofSession', component: EndofSession, props: { goBack, goHome: () => setCurrentPageWithHistory('home') } },
        { name: 'myAccount', component: MyAccount, props: { goBack, setCurrentPage: setCurrentPageWithHistory } },
    ];

    useEffect(() => {
        // Scroll to top whenever the currentPage changes
        window.scrollTo(0, 0);
    }, [currentPage]);

    // GPC handling removed (no-op) because the opt-out flag isn't used elsewhere.

    return (
        <div>
            <ToastContainer />
            <AnimatedHelperWrapper />
            {/* Unified render logic: only one component rendered per page */}
            {(() => {
                let compName = null;
                if (typeof currentPage === 'object' && currentPage !== null && currentPage.component) {
                    compName = getComponentNameFromResumeObj(currentPage);
                } else if (typeof currentPage === 'string') {
                    compName = currentPage;
                }
                if (compName) {
                    const found = components.find(
                        c => c.name.toLowerCase() === compName.toLowerCase()
                    );
                    if (found) {
                        return (
                            <found.component
                                goBack={goBack}
                                goHome={() => setCurrentPageWithHistory('home')}
                                navigateTo={navigateTo}
                                {...found.props}
                            />
                        );
                    }
                    // Fallback: try direct string match for special cases
                    if (compName === 'knowThyself') {
                        return (
                            <KnowThyself
                                goBack={goBack}
                                goHome={() => setCurrentPageWithHistory('home')}
                                handleSaveProgress={() => handleSaveProgress('KnowThyself')}
                                navigateTo={navigateTo}
                            />
                        );
                    }
                    if (compName === 'rightForYou' || compName === 'healingFormulasPage/rightForYou') {
                        return (
                            <RightForYou
                                goBack={goBack}
                                goHome={() => setCurrentPageWithHistory('home')}
                                handleSaveProgress={handleSaveProgress}
                            />
                        );
                    }
                    // Add more fallback cases as needed
                    // Don't render a persistent message in the DOM. Show a one-time toast instead.
                    if (!resumeErrorShownRef.current) {
                        toast.error('Could not resume last session. Please start a new session.');
                        resumeErrorShownRef.current = true;
                    }
                    return null;
                }
                return null;
            })()}
            {currentPage === 'login' && <Login setCurrentPage={setCurrentPageWithHistory} plans={plans} />}
            {currentPage === 'signup' && (
                <SignUp
                    membershipType={membershipType}
                    setMembershipType={setMembershipType}
                    setCurrentPage={setCurrentPageWithHistory}
                />
            )}
            {currentPage === 'home' && (
                <>
                    <Home
                        goToPage={setCurrentPageWithHistory}
                        resumeLastSession={resumeLastSession}
                    />
                </>
            )}
            {currentPage === 'newSession' && (
                <NewSession
                    navigateTo={setCurrentPageWithHistory}
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                />
            )}
            {currentPage === 'journal' && <Journal goBack={goBack} goHome={() => setCurrentPageWithHistory('home')} />}
            {currentPage === 'meditation' && <Meditation goBack={goBack} goHome={() => setCurrentPageWithHistory('home')} />}
            {currentPage === 'healingFormulasPage' && (
                <>
                    <HealingFormulasPage
                        goBack={goBack}
                        goHome={() => setCurrentPageWithHistory('home')}
                        setPageHistory={setPageHistory}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPageWithHistory}
                    />
                </>
            )}
            {currentPage === 'healingFormulas' && (
                <>
                    <HealingFormulas
                        goBack={goBack}
                        goHome={() => setCurrentPageWithHistory('home')}
                        navigateTo={navigateTo}
                    />
                </>
            )}
            {/* Removed components.map rendering to avoid duplicate renders.
                Rendering of components is now handled by the unified render block above
                which resolves `currentPage` (string or resume object) to a single component.
                If you need per-component special handling, update the unified render logic instead.
            */}
            {currentPage === 'healingFormulasPage/changeABelief' && (
                <ChangeABelief
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                    navigateTo={navigateTo}
                />
            )}
            {currentPage === 'healingFormulasPage/validation' && (
                <Validation
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                    navigateTo={navigateTo}
                />
            )}
            {currentPage === 'healingFormulasPage/witness' && (
                <Witness
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                    navigateTo={navigateTo}
                />
            )}
            {currentPage === 'healingFormulasPage/celebrate' && (
                <Celebrate
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                    navigateTo={navigateTo}
                />
            )}
            {currentPage === 'healingFormulasPage/identifyTheFeeling' && (
                <IdentifyTheFeeling
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                    handleSaveProgress={() => handleSaveProgress('IdentifyTheFeeling')}
                    navigateTo={navigateTo}
                />
            )}
            {currentPage === 'healingFormulasPage/selfCare' && (
                <SelfCare
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                    navigateTo={navigateTo}
                />
            )}
            {currentPage === 'mirror' && (
                <Mirror
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                    handleSaveProgress={async () => await handleSaveProgress('Mirror')}
                    navigateTo={navigateTo}
                />
            )}
            {currentPage === 'acknowledge' && (
                <>
                    <p>Debug: Rendering Acknowledge component</p>
                    <Acknowledge
                        goBack={goBack}
                        goHome={() => setCurrentPageWithHistory('home')}
                        handleSaveProgress={(componentName) => handleSaveProgress(componentName || 'acknowledge')}
                        navigateTo={navigateTo}
                    />
                </>
            )}
            {currentPage === 'selfCare' && (
                <SelfCare
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                    navigateTo={navigateTo}
                />
            )}
            {currentPage === 'companion' && (
                <Companion
                    goToPage={setCurrentPageWithHistory}
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                    navigateTo={navigateTo}
                />
            )}
            {currentPage === 'chat' && (
                <>
                    {/* <p>Debug: Chat page is rendering</p> */}
                    <Chat goBack={goBack} goHome={() => setCurrentPageWithHistory('home')} navigateTo={navigateTo} />
                </>
            )}
            {currentPage === 'Companion' && (
                <Companion
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                    navigateTo={navigateTo}
                />
            )}
            {currentPage === 'astrology' && (
                <Astrology
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                    handleSaveProgress={() => handleSaveProgress('Astrology')}
                    navigateTo={navigateTo}
                />
            )}
            {currentPage === 'knowThyself' && (
                <KnowThyself
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                    handleSaveProgress={() => handleSaveProgress('KnowThyself')}
                    navigateTo={navigateTo}
                />
            )}
            {currentPage === 'qa' && (
                <QA
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                    handleSaveProgress={() => handleSaveProgress('QA')}
                    navigateTo={navigateTo}
                />
            )}
            {currentPage === 'oracle' && (
                <Oracle
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                    navigateTo={navigateTo}
                />
            )}
            {currentPage === 'julieCam' && (
                <JulieCam
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                    navigateTo={navigateTo}
                />
            )}
            {currentPage === 'adminPanel' && (
                <AdminPanel
                    user={user}
                    goBack={goBack}
                    goHome={() => setCurrentPageWithHistory('home')}
                    setCurrentPage={setCurrentPageWithHistory}
                    navigateTo={navigateTo}
                />
            )}
        </div>
    );
};

const App = () => (
    <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<AppContent />} />
    </Routes>
);

const isAdmin = (user) => {
    return user && user.role === 'admin';
};

export default App;